export const stringToCode = (element: any) => {
  const content = element.textContent;

  function toNode(iframeString: string) {
    const div = document.createElement('div');
    div.innerHTML = iframeString;
    const isYoutubePlayer = iframeString.includes('youtube.com');
    if (isYoutubePlayer) div.classList.add('youtube-player-wrapper');
    return div;
  }

  const parent = element.parentNode;
  const childOembed = parent.querySelector('code');
  childOembed.replaceWith(toNode(content));
};
